<template>
    <div class="popup__wrap">
        <div class="popup__header">
            <div class="popup__image mr-2"></div>
            <div class="popup__title">
                {{ title }}
            </div>
        </div>
        <div class="popup__message">
            {{ description }}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: [Number, String],
                default: 'Error Message Error Message Error Message',
            },
            description: {
                type: [Number, String],
                default: '',
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/pop-up/ErrorDownload.vue